"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("egov-ui-kit/redux/form/actions");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "ownershipType",
  fields: {
    ownerShipCategoryDropDown: {
      id: "ownerShipCategoryDropDown",
      jsonPath: "Properties[0].ownershipCategory",
      required: true,
      type: "singleValueList",
      floatingLabelText: "Ownership Category",
      errorMessage: "required!",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5, color: "red" },
      fullWidth: true,
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions.setFieldProperty)("propertyAddress", "ownerShipCategoryDropDown", "value", field.value));
        dispatch((0, _actions2.prepareFinalObject)("Properties[0].ownershipCategory", field.value));
      }
    },
    personLiableToPayTax: {
      id: "personLiableToPayTax",
      jsonPath: "Properties[0].personLiableTax",
      type: "textfield",
      floatingLabelText: "Person Liable To PayTax",
      hintText: "",
      required: false,
      disabled: false,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!"
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var ownerShipTypeData = [{ name: "State Govt Premises", code: "State Govt Premises", value: "State Govt Premises", label: "State Govt Premises" }, { name: "Central Govt Premises", code: "Central Govt Premises", value: "Central Govt Premises", label: "Central Govt Premises" }, { name: "Statutory Bodies", code: "Statutory Bodies", value: "Statutory Bodies", label: "Statutory Bodies" }, { name: "Thika Premises", code: "Thika Premises", value: "Thika Premises", label: "Thika Premises" }, { name: "Bustee Premises", code: "Bustee Premises", value: "Bustee Premises", label: "Bustee Premises" }, { name: "Khasmahal Property", code: "Khasmahal Property", value: "Khasmahal Property", label: "Khasmahal Property" }, { name: "Private Property", code: "Private Property", value: "Private Property", label: "Private Property" }];

    dispatch((0, _actions.setFieldProperty)("ownershipType", "ownerShipCategoryDropDown", "dropDownData", ownerShipTypeData));
    return action;
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: true
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/ownershipType.js
// module id = 1683
// module chunks = 1137